define('ordersReviewView',[
  'app',
  'module',
  'marionette',
  'underscore',
  'template!ordersReviewView'
], function (
  App,
  Module,
  Marionette,
  _,
  Tpl
) {
  'use strict';

  Module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'orders-review-view',

    ui: {
      review: '.review'
    },

    events: {
      'click .review': 'onClickReview'
    },

    modelEvents: {
      'change:reviewEnabled': 'render'
    },

    onRender: function () {
      if (this.model.get('reviewEnabled')) {
        this.ui.review.addClass('active');
        this.ui.review.attr('title', _.i18n ? _.i18n('common.reviewEnabled') : 'Enabled');
      } else {
        this.ui.review.removeClass('active');
        this.ui.review.attr('title', _.i18n ? _.i18n('common.reviewDisabled') : 'Disabled');
      }
    },

    onClickReview: function (e) {
      e.stopPropagation();
      e.preventDefault();
      var current = !!this.model.get('reviewEnabled');
      this.model.updateReviewEnabled(!current).done(_.bind(function () {
        this.model.fetch();
      }, this));
    }
  });
});

